export const setStartOfDay = (dateString: string) => {
  const [year, month, day] = dateString.split('T')[0].split('-').map(Number)

  return new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0))
}

export const setEndOfDay = (dateString: string) => {
  const [year, month, day] = dateString.split('T')[0].split('-').map(Number)

  return new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999))
}
